import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
export function HarbourIsleProperties() {
  return <main className="flex min-h-screen w-full flex-col bg-amber-950 text-amber-50" data-id="element-134" data-mp="24bi3flq22z8n">
      <section className="flex flex-1 items-center px-6 py-16 sm:px-10 lg:px-14" data-id="element-135" data-mp="299rxtu3yhvt7">
        <div className="mx-auto w-full max-w-3xl" data-id="element-136" data-mp="297oz8loqmucv">
          <Link to="/mls-listings" className="inline-flex items-center gap-2 text-sm font-bold text-amber-100 transition-[color] duration-200 hover:text-white" data-id="element-137" data-mp="1v9h66outod6z">
            <ArrowLeftIcon size={17} aria-hidden="true" data-id="element-138" data-mp="1ld5otkgdkx5o" />
            Back to Available Listings
          </Link>
          <p className="mt-16 text-xs font-bold uppercase tracking-[0.18em] text-amber-300" data-id="element-139" data-mp="1qbpenvy3at3b">Harbour Isle · Fort Pierce</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.92] sm:text-7xl" data-id="element-140" data-mp="3fo0ykq3aqia1">Harbour Isle properties.</h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-amber-100" data-id="element-141" data-mp="3kmudmmy8ehcb">
            A dedicated collection of Harbour Isle properties is coming soon. Check back for curated listings, rentals, and neighborhood highlights.
          </p>
        </div>
      </section>
      <SiteFooter tone="warm" data-id="element-142" data-mp="1zu1jbxc30d8b" />
    </main>;
}